/* eslint-ignore */
// @ts-nocheck
export const stepsProvider = [
  {
    id: 1,
    number: '1',
    description: 'Sua identificação',
  },
  {
    id: 2,
    number: '2',
    description: 'Dados cadastrais',
  },
  {
    id: 3,
    number: '3',
    description: 'Cadastro de Senha',
  },
  {
    id: 4,
    number: '4',
    description: 'Validação',
  },
  {
    id: 5,
    number: '5',
    description: 'Fim',
  },
];
